<template lang="pug">
  header
    .sticky-mobile-bar(:class="stickyHeaderClass")
      button.hamburger.hamburger--3dy(
        type="button"
        :class="{ 'is-active': sidebar }"
        @click="toggleSidebar"
      )
        span.hamburger-box
          span.hamburger-inner
      ShoppingCart
    Menu#header-menu(k="header-menu" :max-depth="1")
    .flex.w-full.my-8
      .logo
        a(href="/")
          img(v-if="logo && logo.id" :src="image.src" title="logo" rel="noopener")
          img(v-else src="@/assets/logo.png")
      Menu#main-menu(k="main-menu" :max-depth="3")
    //- .desktop-navbar
    //-   .logo-wrapper
    //-     img#logo(v-if="logo && logo.id" :src="image.src" title="logo" rel="noopener")
    //-     img#logo(v-else src="@/assets/logo.png")
    //-   .main-menu-wrapper
    //-     Menu#header-menu(k="header-menu" :max-depth="1")
    //-     //- nav#main-menu
    //-     //-   TreeMenu(:items="items" :max-depth="2" :delay="400")
    //-     //- a.search.icon.is-large(href="#" @click.prevent="openSearch")
    //-     //-   font-awesome-icon(icon="search")
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

import { trim } from '@/helpers';

import Menu from '@/components/Menu.vue';
import ShoppingCart from '@/extensions/shop/components/ShoppingCart.vue';

export default {
  name: 'Header',
  data: () => ({
    lastScroll: 0,
    stickyHeaderClass: ''
  }),
  components: {
    Menu,
    ShoppingCart
  },
  computed: {
    image() {
      const storageRoute = trim(
        `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`,
        '/'
      );

      const fit = 'fit=fill&w=350&h=150';

      let width = this.logo.width;
      let height = this.logo.height;

      return {
        src: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}`,
        error: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}&preview=greyscale`,
        loading: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}&preview=blur`,
        width,
        height
      };
    },
    ...mapGetters({
      logo: 'logo',
      menus: 'menus',
      sidebar: 'sidebar'
    })
  },
  methods: {
    openSearch() {
      console.log('open search bar');
    },
    toggleSidebar() {
      this.updateSidebarVisibility(!this.sidebar);
    },
    updateStickyHeader() {
      const currentScroll = window.pageYOffset;

      const scrollUp = 'scroll-up';
      const scrollDown = 'scroll-down';

      if (currentScroll > this.lastScroll && this.stickyHeaderClass !== scrollDown) {
        this.stickyHeaderClass = scrollDown;
      } else if (currentScroll < this.lastScroll && this.stickyHeaderClass !== scrollUp) {
        this.stickyHeaderClass = scrollUp;
      }

      this.lastScroll = currentScroll;
    },
    ...mapMutations({
      updateSidebarVisibility: 'updateSidebarVisibility'
    })
  },
  mounted() {
    window.addEventListener('scroll', this.updateStickyHeader);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.updateStickyHeader);
  }
};
</script>

<style lang="sass" nolang="scss" scoped>
@import "~@/assets/sass/variables"

header
  display: flex
  // justify-content: space-between
  align-items: center
  font-weight: 400
  justify-content: flex-end
  flex-direction: column
  padding-top: 53px
  @screen lg
    padding-top: 0
  .logo
    padding: 1rem
    @screen lg
      padding-bottom: 1rem
      padding-left: 3rem
    img
      max-height: 90px
      max-width: 235px
  .flex
    justify-content: center
    margin-top: 0
    @screen lg
      justify-content: initial
      margin-top: 2rem

  ::v-deep
    .search
      flex-grow: 0
      flex-shrink: 0
      flex-basis: 60px
      button
        @apply text-black
        width: 24px
        height: 38px
        font-size: 2rem
        line-height: 0

  .sticky-mobile-bar
    @apply flex justify-between items-center
    position: fixed
    top: 0
    left: 0
    width: 100%
    background: rgba(255, 255, 255, .8)
    backdrop-filter: blur(20px)
    transition: transform .15s linear
    z-index: 10
    @screen lg
      @apply hidden
    &.scroll-down
      transform: translateY(-54px)
    .hamburger
      height: 53px
      padding: 1rem
    .shopping-cart
      padding: 0 1rem
</style>
